import React from 'react';

const ContactModal = ({ onClose }) => {
  const handleGithubIssue = () => {
    window.open('https://github.com/yourusername/quran-reader/issues/new', '_blank');
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" role="dialog" aria-modal="true" aria-label="Contact Us">
      <div 
        className="rounded-lg shadow-xl max-w-md w-full p-6 animate-fadeIn"
        style={{ backgroundColor: 'var(--color-card-bg)' }}
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-heading font-kufi">Contact Us</h2>
          <button 
            onClick={onClose}
            className="focus:outline-none"
            style={{ color: 'var(--color-charcoal)', opacity: 0.5 }}
          >
            <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <div className="mb-6">
          <p className="mb-4 font-lato" style={{ color: 'var(--color-charcoal)', opacity: 0.7 }}>
            We appreciate your feedback and suggestions for improving the Quran Reader application.
          </p>
          <p className="mb-4 font-lato" style={{ color: 'var(--color-charcoal)', opacity: 0.7 }}>
            To report an issue, request a feature, or provide feedback, please open an issue on our GitHub repository.
          </p>
        </div>
        
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-md transition-colors font-lato"
            style={{ backgroundColor: 'var(--color-light-gray)', color: 'var(--color-charcoal)' }}
          >
            Cancel
          </button>
          <button
            onClick={handleGithubIssue}
            className="px-4 py-2 bg-deep-green rounded-md transition-colors font-lato flex items-center"
            style={{ color: 'var(--color-header-text)' }}
          >
            <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
            </svg>
            Open GitHub Issue
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;